export default __webpack_public_path__ + "static/media/regulatory--reversible-lanes--g1.9fb06219.png";